import styled, { css } from "styled-components"
import { BaseCard } from "../base-card/base-card.styles"
import ButtonLink from "../btn-collections/btn-collections.component"
import cross from "../../svg/cross.svg"
import tick from "../../svg/Tick_icon.svg"

export const FocusCardContainer = styled(BaseCard)`
  width: 34%;
  align-self: center;
  border-radius: 25px;
  transform: scale(1.08);
  z-index: 5;
  @media screen and (max-width: 1080px) {
    margin: 50px 0;
    width: 100%;
    transform: scale(1.06) !important;
  }
  @media screen and (max-width: 768px) {
    transform: none !important;
    margin: 20px 0;
    width: 99vw;
    margin-left: -50vw;
    margin-right: -50vw;
  }
`

const platformTitleStyle = css`
  text-align: center;
  padding: 40px;
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.bold};
  text-transform: uppercase;
  border-top-left-radius: ${({ order }) => (order === 2 ? "0px" : "25px")};
  border-top-right-radius: ${({ order }) => (order === 0 ? "0px" : "25px")};
  @media screen and (max-width: 1080px) {
    border-radius: 25px 25px 0 0;
  }
  & h3 {
    font-size: 32px;
    line-height: 42px;
    margin-bottom: 13px;
    @media screen and (max-width: 768px) {
      margin-top: 10px;
    }
  }
  & div {
    font-size: 32px;
    line-height: 42px;
    margin-bottom: 13px;
    @media screen and (max-width: 768px) {
      margin-top: 10px;
    }
  }
  @media screen and (max-width: 768px) {
    padding: 30px;
  }
`
export const PlatformContainer = styled.div`
  background-color: ${({ theme: { colors } }) => colors.accentPink};
  color: #fff;
  ${platformTitleStyle}
`
export const OtherPlatformContainer = styled.div`
  background-color: ${({ theme: { colors } }) => colors.darkGrey};
  color: ${({ theme: { colors } }) => colors.lightGrey};
  ${platformTitleStyle};
`

export const CardContainer = styled.div`
  width: 33%;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  text-align: center;
  background-color: #fff;
  border-radius: 25px;
  @media screen and (max-width: 1080px) {
    width: 100%;
    margin-top: 0px;
  }
`
export const ContentContainer = styled.div`
  padding-top: 30px;
  padding-right: ${({ order }) => (order === 0 ? "55px" : "35px")};
  padding-bottom: ${({ order }) => (order === 1 ? "35px" : "10px")};
  padding-left: ${({ order }) => (order === 2 ? "55px" : "35px")};
  font-size: 30px;
  color: ${({ theme: { colors } }) => colors.darkGrey};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  @media screen and (max-width: 1080px) {
    padding: 35px;
    padding-bottom: ${({ order }) => (order === 1 ? "35px" : "10px")};
  }
  @media screen and (max-width: 768px) {
    padding: 25px;
    padding-bottom: ${({ order }) => (order === 1 ? "30px" : "5px")};
  }
`

export const CtaButton = styled(ButtonLink)`
  width: 100%;
  margin: 0 auto;
  padding: 15px;
  height: unset;
`

export const ListContainer = styled.ul`
  padding-inline-start: 0;
  height: 100%;
  flex: 1 1 0;
  margin-top: 0;
  margin-bottom: 25px;
  text-align: left;
  li {
    display: flex;
    list-style: none;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 20px;
    color: ${({ theme: { colors } }) => colors.darkGrey};
    /*mobile view list text*/
    @media screen and (max-width: 768px) {
      font-size: 18px;
      line-height: 28px;
    }
  }
`

export const ListItemContainer = styled.div`
  width: 100%;
  a {
    color: ${({ theme: { colors } }) => colors.hyperLinkPink};
    :hover,
    :active {
      text-decoration-thickness: 2px;
    }
  }
`

export const CrossIcon = styled(cross)`
  width: 35px;
  height: 30px;
  margin-right: 25px;
  border-radius: 50%;
  @media screen and (max-width: 1080px) {
    width: 30px;
  }
  @media screen and (max-width: 768px) {
    margin-right: 20px;
  }
`
export const TickIcon = styled(tick)`
  margin-right: 25px;
  width: 35px;
  @media screen and (max-width: 768px) {
    margin-right: 20px;
    width: 30px;
  }
`
